import { ApiBase } from "./api-base.js";
import { checkStandardApiError } from "./error-handling.js";
import { IStandardApiError } from "./i-standard-api-error.js";

export abstract class ApiBaseWithStandardErrorHandling extends ApiBase {
    constructor(basePath: string) {
        super(basePath);
    }

    protected abstract reportError(error: IStandardApiError): void;

    protected override checkError(response: Response): Promise<boolean> {
        return checkStandardApiError(response, true, (error) => this.reportError(error));
    }
}
